import css from "styled-jsx/css";

const TAB_CONTENT_PADDING = "40px";

export const componentStyles = css.global`
  .side-by-side-tabs-and-process-tabs-mobile-component {
    .mobile-wrapper {
      .mobile-timer-tabs-component {
        padding-right: 0;
        padding-left: 0;

        .vertical-timer-tab-mobile-component {
          padding: ${`0 ${TAB_CONTENT_PADDING}`};

          .vertical-timer-tab-mobile-title {
            padding-top: 8px;
            padding-bottom: 8px;
          }

          &:has(> div.vertical-timer-tab-mobile-title-selected) {
            background-color: var(--selected-tab-background-color);
          }
          .vertical-timer-tab-mobile-content-container {
            .vertical-timer-tab-mobile-content {
              .paragraph-body {
                font-size: 1rem;
                margin-bottom: 24px;
              }
            }

            .process-tabs {
              .mobile-wrapper {
                .use-cases-tabs-mobile-component {
                  .mobile-tabs-component {
                    .mobile-tabs-navigation {
                      margin-right: ${`-${TAB_CONTENT_PADDING}`};
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
